import { useGetProductById } from 'hooks/useProduct';
import React, { createContext, useContext } from 'react';

interface ProductContextType {
  product: any | null;
  productId: string;
  refetch: () => void;
}

const ProductContext = createContext<ProductContextType | undefined>(undefined);

export const useProductContext = () => {
  const context = useContext(ProductContext);
  if (!context) {
    throw new Error('useProductContext must be used within a ProductProvider');
  }
  return context;
};

interface ProductProviderProps {
  children: React.ReactNode;
  productId: string;
}

export const ProductProvider = ({ children, productId }: ProductProviderProps) => {
  const { data: product, refetch } = useGetProductById(productId, {
    select: (res: any) => res.data,

  });

  return (
    <ProductContext.Provider value={{ product, productId, refetch }}>
      {children}
    </ProductContext.Provider>
  );
};